<template>
  <div class="examination" v-loading="loading">
    <el-form ref="form" :model="form" label-width="80px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="考试状态">
            <el-select v-model="form.paperStatus" placeholder="请选择" clearable>
              <el-option label="未开始" :value="2"></el-option>
              <el-option label="进行中" :value="3"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- <el-form-item label="活动名称">
            <el-select v-model="form.region" placeholder="请选择活动区域">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item> -->
        </el-col>
        <el-col :span="9">
          <div style="height: 1px"></div>
        </el-col>
        <el-col :span="3">
          <el-button type="primary" @click="filter">筛选</el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-table
      ref="multipleTable"
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="paper_name" label="考试名称"></el-table-column>
      <el-table-column prop="total_taken_num" label="应考人数"></el-table-column>
      <el-table-column prop="has_taken_num" label="已考人数"></el-table-column>
      <el-table-column prop="pass_taken_num" label="通过人数"></el-table-column>
      <!-- <el-table-column prop="address" label="未通过人数"></el-table-column> -->
      <el-table-column prop="start_time" label="试卷有效时间（开始）">
        <template #default="{ row }">
          {{ row.start_time ? $moment(row.start_time * 1000).format('YYYY/MM/DD HH:mm:ss') : '--' }}
        </template>
      </el-table-column>
      <el-table-column prop="stop_time" label="试卷有效时间（结束）">
        <template #default="{ row }">
          {{ row.stop_time ? $moment(row.stop_time * 1000).format('YYYY/MM/DD HH:mm:ss') : '--' }}
        </template>
      </el-table-column>
      <el-table-column prop="paper_status" label="状态"></el-table-column>
      <el-table-column prop="remark" label="备注"></el-table-column>
      <el-table-column prop="update_user" label="最后更新人"></el-table-column>
      <el-table-column prop="update_time" label="最后更新时间">
        <template #default="{ row }">
          {{
            row.update_time ? $moment(row.update_time * 1000).format('YYYY/MM/DD HH:mm:ss') : '--'
          }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="marginTop"
      layout="total, prev, pager, next, jumper"
      :total="total"
      :page-size="size"
      @current-change="setIndex"
    />
    <div class="marginTop">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="save">保存</el-button>
    </div>
  </div>
</template>

<script>
import { GetExaminationPaperList } from '@/api/examPaperManagement.js';
export default {
  data() {
    return {
      form: {
        paperStatus: '',
      },
      total: 0,
      size: 10,
      index: 1,
      tableData: [],
      sortList: [],
      loading: false,
      paperStatus: undefined,
    };
  },
  created() {
    this.getTableData();
  },
  methods: {
    filter() {
      this.index = 1;
      this.getTableData();
    },
    setIndex(e) {
      this.index = e;
      this.getTableData();
    },
    onSubmit() {},
    // handleSelectionChange(res) {
    //   console.log(res);
    //   this.selectList = res;
    // },
    // 触发选择
    handleSelectionChange(val) {
      if (val.length > 1) {
        this.$refs.multipleTable.clearSelection();
        this.sortList = val.pop();
        this.$refs.multipleTable.toggleRowSelection(this.sortList);
      } else {
        this.sortList = val;
      }
    },
    cancel() {
      this.$emit('cancel');
    },
    save() {
      this.$emit('examination', this.sortList);
    },
    getTableData() {
      this.loading = true;
      console.log(GetExaminationPaperList);
      GetExaminationPaperList({
        page_index: this.index,
        page_size: this.size,
        paper_status_list: this.form.paperStatus ? [this.form.paperStatus] : [2, 3],
        attach_article: 0,
      })
        .then((res) => {
          console.log(res, 'GetExaminationPaperList');
          this.total = res.total;
          this.tableData = res.paper_list;
        })
        .catch((err) => {
          this.$message.error(err.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.marginTop {
  margin-top: 20px;
}
</style>
